import React from 'react';

import Youtube from 'react-icons/lib/io/social-youtube';
import Twitch from 'react-icons/lib/io/social-twitch';
import Facebook from 'react-icons/lib/io/social-facebook';
import Twitter from 'react-icons/lib/io/social-twitter';
import GooglePlus from 'react-icons/lib/io/social-googleplus';
import Instagram from 'react-icons/lib/io/social-instagram';
import Snapchat from 'react-icons/lib/io/social-snapchat';

const PlatformIcons = {
  youtube: Youtube,
  twitch: Twitch,
  facebook: Facebook,
  twitter: Twitter,
  googleplus: GooglePlus,
  instagram: Instagram,
  snapchat: Snapchat,
};

function PlatformIcon(slug, props) {
  const Element = PlatformIcons[slug];
  return <Element fill={props.color} style={props.style} />;
}

export default PlatformIcon;



/** WEBPACK FOOTER **
 ** ./components/PlatformIcon.js
 **/